<template>
    <span>

        <div class="ItemTreeHDLFolder">

            <li>
                <div class="treeline">
                    <div class="expand__container">
                        <img class="expandimage"
                            v-if="isFolder !== undefined && open == false && model.children.length > 0" @click="toggle"
                            src="/static/branch-collapsed.png">


                        <img class="expandimage"
                            v-if="isFolder !== undefined && open == true && model.children.length > 0" @click="toggle"
                            src="/static/branch-expanded-dark.png">


                        <img class="expandimage" v-if="!isFolder" src="/static/transparent_icon_24.png">
                    </div>

                    <span v-if="model.type === 'folder' && !model.isVariant" class="folder"></span>
                    <span v-if="model.type === 'folder' && model.isVariant" class="folder-variant"
                        v-b-tooltip.hover.topleft :title="model.variantName"></span>
                    <!-- <span v-if="model.type !== 'folder'" class="nofolder"></span> -->
                    <img v-if="model.type !== 'folder'" width=16px :src="filenameToIcon(model.name)">


                    <a v-if="model.type === folder"
                        class="category__name" :data-rev="revisionId" v-bind:class="{ active: isActive }"
                        @click="selectResource(revisionId)">{{ model.name }}
                    </a>
                    <!-- <a v-if="model.type === folder &&  isOwnerOfDelegation == false && currentUser.userId !== model.delegatedUserId && isOwner == false"
                        class="category__name" :data-rev="revisionId" v-bind:class="{ active: isActive }"
                        @click="selectResource(revisionId)" v-b-tooltip.hover.topright
                        :title="'delegated to: ' + model.delegatedLogin + ' (' + delegatedDate + ')'">{{ model.name }} |
                        <b-badge class="badge-delegate" variant="danger">D
                        </b-badge>
                    </a>
                    <a v-if="model.type === folder && isOwnerOfDelegation == true && isOwner == false"
                        class="category__name" :data-rev="revisionId" v-bind:class="{ active: isActive }"
                        @click="selectResource(revisionId)" v-b-tooltip.hover.topright
                        :title="'delegated to: ' + model.delegatedLogin + ' (' + delegatedDate + ')'">{{ model.name }} |
                        <b-badge class="badge-delegate" variant="success">D</b-badge>
                    </a>
                    <a v-if="model.type === folder &&  isOwnerOfDelegation == false && isOwner == true"
                        class="category__name" :data-rev="revisionId" v-bind:class="{ active: isActive }"
                        @click="selectResource(revisionId)" v-b-tooltip.hover.topright
                        :title="'delegated to: ' + model.delegatedLogin + ' (' + delegatedDate + ')'">{{ model.name }} |
                        <b-badge class="badge-delegate" variant="danger">D</b-badge>
                    </a> -->



                    <a v-if="model.type !== folder" class="category__name" :data-rev="revisionId" v-bind:class="{ active: isActive }" @click="selectResource(revisionId)"
                        v-b-tooltip.hover.topright :title="model.fileSize + 'B | ' + modificationDate">{{shorterName}}
                        <!-- <span v-show="model.fileRevision != 0 && this.parent=='details'"> |
                        </span>
                        <b-badge class="badge-file-rev" variant="primary"
                            v-show="model.fileRevision != 0 && this.parent == 'details'">{{ model.fileRevision }}
                        </b-badge> -->

                    </a>
                    <!-- <a v-if="model.type !== folder"
                        v-show="model.delegatedFile == true && isOwnerOfDelegation == false && currentUser.userId !== model.delegatedUserId && isOwner == false"
                        class="category__name" :data-rev="revisionId" v-bind:class="{ active: isActive }"
                        @click="selectResource(revisionId)" v-b-tooltip.hover.topright
                        :title="model.fileSize + ' | ' + modificationDate + ' | delegated to: ' + model.delegatedLogin + ' (' + delegatedDate + ')'">{{
                            shorterName
                        }}<span v-show="model.fileRevision != 0"> |
                        </span>
                        <b-badge class="badge-file-rev" variant="primary"
                            v-show="model.fileRevision != 0">{{ model.fileRevision }}
                        </b-badge>
                        <b-badge class="badge-delegate" variant="danger">D</b-badge>

                    </a>
                    <a v-if="model.type !== folder"
                        v-show="model.delegatedFile == true && isOwnerOfDelegation == true && isOwner == false"
                        class="category__name" :data-rev="revisionId" v-bind:class="{ active: isActive }"
                        @click="selectResource(revisionId)" v-b-tooltip.hover.topright
                        :title="model.fileSize + ' | ' + modificationDate + ' | delegated to: ' + model.delegatedLogin + ' (' + delegatedDate + ')'">{{
                            shorterName
                        }}<span v-show="model.fileRevision != 0"> |
                        </span>
                        <b-badge class="badge-file-rev" variant="primary"
                            v-show="model.fileRevision != 0">{{ model.fileRevision }}
                        </b-badge>
                        <b-badge class="badge-delegate" variant="success">D</b-badge>
                    </a>
                    <a v-if="model.type !== folder"
                        v-show="model.delegatedFile == true && isOwnerOfDelegation == false && isOwner == true"
                        class="category__name" :data-rev="revisionId" v-bind:class="{ active: isActive }"
                        @click="selectResource(revisionId)" v-b-tooltip.hover.topright
                        :title="model.fileSize + ' | ' + modificationDate + ' | delegated to: ' + model.delegatedLogin + ' (' + delegatedDate + ')'">{{
                            shorterName
                        }}<span v-show="model.fileRevision != 0"> |
                        </span>
                        <b-badge class="badge-file-rev" variant="primary"
                            v-show="model.fileRevision != 0">{{ model.fileRevision }}
                        </b-badge>
                        <b-badge class="badge-delegate" variant="danger">D</b-badge>
                    </a> -->

                    
                </div>

                <ul v-show="open" v-if="isFolder" class="library_ul">
                    <ItemTreeHDLFolder :isPending="isPending" :revisionId="revisionId" :action="action"
                        class="library_item" :lang="lang" v-for="model in model.children" :model="model" :edit="edit"
                        :key="model.folderId" :isLastRevision="isLastRevision" :parent="parent">
                    </ItemTreeHDLFolder>
                </ul>




            </li>
        </div>

    </span>
</template>

<script>

import { mapGetters } from 'vuex'
import * as Tools from './../../Tools/Tools'

export default {
    name: 'ItemTreeHDLFolder',
    props: {
        model: Object,
        edit: Boolean,
        lang: Object,
        action: Boolean,
        revisionId: Number,
        isPending: Boolean,
        isLastRevision: Boolean,
        parent: String
    },
    data: function () {
        return {
            open: true,
            folder: "folder",
            showButton: false,


/*
            objAlertSuccess: {
                text: this.lang.alert_success_delete_category,
                type: "success", //success, danger, warning, info
                time: 5 //sec.

            },
            objAlertError: {
                text: this.lang.alert_error_delete_category,
                type: "danger", //success, danger, warning, info
                time: 5 //sec.
            },
*/

        };
    },
    computed: {
        ...mapGetters({

            currentUser: 'currentUser',

        }),

        variant() {
            if (this.$store.getters.s_skinVariant == "dark") {
                return "light";
            } else {
                return "dark";
            }

        },
        isOwner() {

            return this.$store.getters.selectedRows[0].col___revisionId.userId == this.$store.getters.currentUser.userId;
        },
        itemId() {
            if (this.model.type == "folder") {

                return this.model.folderId;
            }

            if (this.model.type == "file") {

                return this.model.fileId;
            }
        },
        modificationDate() {
            return Tools.longDateToShort(this.model.modificationDate);
        },
        delegatedDate() {
            return Tools.longDateToShort(this.model.delegatedDate);
        },
        isFolder: function () {

            if (this.model.children == undefined) {
                return

            }
            return this.model.children.length > 0;
        },
        isActive() {


            if (this.$store.getters.selectedTreeFolderItemObject.type == "folder") {

                return this.$store.getters.selectedTreeFolderItemObject.folderId == this.model.folderId;
            }

            if (this.$store.getters.selectedTreeFolderItemObject.type == "file") {

                return this.$store.getters.selectedTreeFolderItemObject.fileId == this.model.fileId;
            }

            return ""
        },
        uid() {

            return this._uid
        },
        classObject() {
            return {
                active: this.isActive
            }
        },
        isDelegated() {
            

            return false;
        },
        isDelegatedReject() {
            

            return false;
        },
        isDelegatedUndo() {
            
            return false;
        },
        isDelegatedCommit() {
            
            return false;
        },
        isDelegatedButNotParent() {
            
            return false;
        },
        isNotDelegatedAndIsParent() {

            let trig = false;
            
            return trig;
        },
        isOwnerOfDelegation() {
            
            return false;
        },
        
        shorterName() {
            let str = this.model.name;
            if (this.model.name != undefined) {


                let first = this.model.name.substr(0, 20);
                let second = this.model.name.substr(this.model.name.length - 20, 20);
                if (this.model.name.length > 50) {
                    str = first + "..." + second;
                }
            }

            return str;
        }

    },
    mounted() {

    },
    updated() {

    },
    watch: {

    },
    methods: {
        filenameToIcon(data) {
            return Tools.filenameToIcon(data)
        },
        toggle: function () {

            if (this.isFolder) {
                this.open = !this.open;
            }

        },
        
        downloadItem() {


            let vue = this;

            if (this.model.type == "folder") {
                const obj = {
                    folderId: vue.model.folderId,

                }
                this.$store.dispatch(this.$store.getters.sectionPrefix + "_getProjectFiles", obj)
                    .then(function (result) {

                        console.log(result)



                        if (result.size != null && result.size != undefined) {


                            let fileName = vue.model.name + ".zip";

                            var a = document.createElement("a");
                            a.href = URL.createObjectURL(result);
                            a.download = fileName;

                            document.body.appendChild(a);

                            a.click();
                            document.body.removeChild(a);

                            let obj = {
                                text: vue.lang.alert_success_download_file,
                                time: 10,
                                type: "success"
                            };

                            vue.$store.dispatch("displayFooterAlert", obj);



                        } else {

                            let obj = {
                                text: vue.lang.alert_error_download_file + ": " + result.message,
                                time: 15,
                                type: "danger"
                            };

                            vue.$store.dispatch("displayFooterAlert", obj);
                        }



                    })

            } else {
                const obj = {
                    documentId: vue.model.fileId,
                    revisionId: vue.revisionId
                }
                this.$store.dispatch(this.$store.getters.sectionPrefix + "_downloadFile", obj)
                    .then(function (result) {



                        if (result.size != null && result.size != undefined) {

                            let fileName = vue.model.name;

                            var a = document.createElement("a");
                            a.href = URL.createObjectURL(result);
                            a.download = fileName;

                            document.body.appendChild(a);

                            a.click();
                            document.body.removeChild(a);

                            let obj = {
                                text: vue.lang.alert_success_download_file,
                                time: 10,
                                type: "success"
                            };

                            vue.$store.dispatch("displayFooterAlert", obj);

                        } else {

                            let obj = {
                                text: vue.lang.alert_error_download_file + ": " + result.message,
                                time: 15,
                                type: "danger"
                            };

                            vue.$store.dispatch("displayFooterAlert", obj);

                        }






                    })
            }


        },
        

        
        selectResource(revisionId) {
            /*
                  
            let actionButtons = document.querySelectorAll(".actionButtonFolder");
            
            
            for(let button of actionButtons){
              
              if (this.revisionId == revisionId) {
                
                // if (this.model.type == "folder") {
                //   id = "id_" + this.model.folderId + "_" + this.revisionId;
                // }
                
                // if (this.model.type == "file"){
                //   id = "id_" + this.model.fileId + "_" + this.revisionId;
                // }
                let id = "id_" + this.itemId + "_" + this.revisionId;
      
                
                if (button.id === id && button.id !== 1) {
                  
                              
                  button.style.display = "inline";
                  
                }
                if (id !== button.id) {
                  
                  button.style.display="none";
                  
                }
                
                this.$store.dispatch(this.$store.getters.sectionPrefix + "_selectTreeFolderItem", this._uid);
            
                this.$store.dispatch(this.$store.getters.sectionPrefix + "_selectTreeFolderItemObject", this.model);
      
                if (this.action == true){
                  
                  this.$store.dispatch(this.$store.getters.sectionPrefix + "_setElementFolderProject", this.model.category);
                  
                }
              }
              
                
            }*/
            let dropdownMore = document.querySelectorAll(".dropdown-more");

            for (let button of dropdownMore) {

                if (this.revisionId == revisionId) {

                    // if (this.model.type == "folder") {
                    //   id = "id_" + this.model.folderId + "_" + this.revisionId;
                    // }

                    // if (this.model.type == "file"){
                    //   id = "id_" + this.model.fileId + "_" + this.revisionId;
                    // }
                    let id = "id_" + this.itemId + "_" + this.revisionId;


                    if (button.id === id && button.id !== 1) {


                        button.style.display = "inline";

                    }
                    if (id !== button.id) {

                        button.style.display = "none";

                    }

                    // this.$store.dispatch(this.$store.getters.sectionPrefix + "_selectTreeFolderItem", this._uid);

                    // this.$store.dispatch(this.$store.getters.sectionPrefix + "_selectTreeFolderItemObject", this.model);

                    // if (this.action == true) {

                    //     this.$store.dispatch(this.$store.getters.sectionPrefix + "_setElementFolderProject", this.model.category);

                    // }
                }


            }


        },
        changeType: function () {
            if (!this.isFolder) {
                Vue.set(this.model, 'children', []);
                this.addChild();
                this.open = true;
            }
        }

    }
}
</script>


<style lang="scss">
.ItemTreeHDLFolder {
    .expandimage {
        width: 16px;
        height: 16px;
        margin-left: 5px;
        margin-right: 5px;
    }

    .expand__container {
        width: 20px;
        height: 15px;
        display: flex;
        justify-content: flex-end;
        align-items: flex-start;
        flex-direction: column;
    }

    .library_item {
        cursor: pointer;

    }

    .library_ul {
        padding-left: 18px;
        line-height: 1.5em;
        list-style-type: none;

    }

    .library_ul_flat {
        padding-left: 0px;
        line-height: 1.5em;
        list-style-type: none;

    }

    .actionButton {
        margin-left: 3px;
        border-radius: 3px;
        border: 1px solid white;
    }

    .category__name {
        cursor: pointer;
        white-space: nowrap;
    }

    .folder {
        background-image: url("/static/folder.svg");
        width: 19px;
        height: 16px;
        //display: block;
        margin-right: 5px;
    }

    .folder-variant {
        background-image: url("/static/folder-variant.svg");
        width: 19px;
        height: 16px;
        //display: block;
        margin-right: 5px;
    }

    .nofolder {
        background-image: url("/static/file_grey.png");
        width: 19px;
        height: 16px;
        //display: block;
        margin-right: 5px;
        float: left;
    }

    .treeline {
        display: inline-flex;
        height: 18px;

        img {
            margin-right: 5px;
        }
    }

    a {
        padding-right: 10px;
        padding-left: 10px;
    }

    .active {
        //margin-left: 5px;
        margin-right: 5px;
        white-space: nowrap;
        //margin-top: 1px;
        //margin-bottom: 1px;
    }

    .actionButton {
        float: left;
    }

    .badge-file-rev {
        padding: 2px;
    }

    .badge-delegate {
        padding: 2px;
        margin: 1px;
    }

    .dropdown-more {
        height: 18px;

        .btn {
            height: 18px;
            margin-top: -2px;
        }

        .btn-sm,
        .btn-group-sm>.btn {
            padding: 0px 3px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/ItemTreeHDLFolder.vue